import {
  Menu,
  MenuButton,
  MenuList,
  Input,
  forwardRef,
  InputGroup,
  InputLeftElement,
  Icon,
  ThemingProps,
} from "@chakra-ui/react";
import { format } from "date-fns";
import React, { useState } from "react";
import { Calendar, DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import { FaRegCalendarAlt } from "react-icons/fa";

interface IDateRangeInputProps {
  name?: string;
  onChange?: Function;
  onClose?: Function;
  defaultValues?: { startDate: Date; endDate: Date };
  size?: ThemingProps["size"];
}

export default function DateRangeInput({
  name,
  onChange,
  defaultValues,
  onClose,
  size = "md",
}: IDateRangeInputProps) {
  const [form, setForm] = useState<{ startDate: Date; endDate: Date }>({
    startDate: defaultValues?.startDate || new Date(),
    endDate: defaultValues?.endDate || addDays(new Date(), 7),
  });

  function handleChange(range: any) {
    setForm({
      ...form,
      startDate: range.range1.startDate,
      endDate: range.range1.endDate,
    });
    onChange?.({
      ...form,
      startDate: range.range1.startDate,
      endDate: range.range1.endDate,
    });
  }

  return (
    <Menu placement="auto" onClose={() => onClose?.(form)}>
      <MenuButton type="button">
        <InputGroup color="grey.700" size={size}>
          <InputLeftElement
            pointerEvents="none"
            children={<Icon as={FaRegCalendarAlt} />}
          />
          <Input
            type="string"
            name={name}
            bg="white"
            // maxW="250px"
            fontSize="sm"
            value={
              format(form.startDate, "yyyy/MM/dd") +
              "-" +
              format(form.endDate, "yyyy/MM/dd")
            }
            id={name}
            readOnly
          />
        </InputGroup>
      </MenuButton>
      <MenuList>
        <DateRangePicker
          // onChange={(item: any) =>
          //   setForm({
          //     ...form,
          //     startDate: item.range1.startDate,
          //     endDate: item.range1.endDate,
          //   })
          // }
          onChange={handleChange}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={2}
          ranges={[form]}
          direction="horizontal"
          rangeColors={["#2CB9A9"]}
        />{" "}
      </MenuList>
    </Menu>
  );
}
